import { injectScript } from '@modules/script'

const siteKey = process.env.VUE_APP_RECAPTCHA_CLIENT
const src = `https://www.google.com/recaptcha/api.js?render=${siteKey}`

injectScript(src)
